import React from 'react';
import { Link } from 'react-router-dom';

export function SchoolGuide() {

    return (
        <section id="SchoolGuide">
            <div className="container-fluid mt-3 guide">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div>
                                <p className="pageTitle text-center">Guide to Submit Request for School Records</p>
                            </div>

                            <div className="card mt-4 overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body d-flex flex-row justify-content-md-start justify-content-md-between flex-md-nowrap flex-wrap">
                                    <div className="order-1 pe-3 guide-number">
                                        <img src="./images/01Guide/1.png" alt="" />
                                    </div>
                                    <div className="guide-title order-md-2 order-3 px-md-3">
                                        Request for School Records
                                    </div>
                                    <div className="order-md-4 order-2 ps-3 guide-icon flex-grow-1 align-self-md-start align-self-end text-right">
                                        <img src="./images/01Guide/School/01.png" alt="" />
                                    </div>
                                    <div className="flex-grow-1 order-md-3 order-4" >
                                        <p className="m-0 px-md-3">
                                            Go to  <a href="https://www.nas.gov.sg/erequest/">https://www.nas.gov.sg/erequest/</a>, click on “Submit Request” tab, and select “School Records”.<br /><br />

                                            NAS can only search for school records transferred to us, and these include attendance or admission records before 1982.<br /><br />

                                            If you have attended school after 1982, please contact the Ministry of Education. If you have a SingPass account, you may click <a rel="noopener noreferrer" target="_blank" href="https://form.gov.sg/#!/5d0b535fe6ca2a00111f3868">here</a> to submit the request for a schooling history letter. If you do not have a Singpass account, <a href="mailto:MOE_DAC@moe.gov.sg" target="">contact MOE</a> for assistance. <br /><br />

                                            For statement of results for O Level or similar examinations, more information can be found at this <a rel="noopener noreferrer" target="_blank" href="https://www.seab.gov.sg/statements-of-results">SEAB webpage</a>.
                                        </p>
                                    </div>

                                </div>
                            </div>

                            <div className="card mt-3 overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body d-flex flex-row justify-content-md-start justify-content-md-between flex-md-nowrap flex-wrap">
                                    <div className="order-1 pe-3 guide-number">
                                        <img src="./images/01Guide/2.png" alt="" />
                                    </div>
                                    <div className="guide-title order-md-2 order-3 px-md-3">
                                        Submit Request Form
                                    </div>
                                    <div className="order-md-4 order-2 ps-3 guide-icon flex-grow-1 align-self-md-start align-self-end text-right">
                                        <img src="./images/01Guide/School/02.png" alt="" />
                                    </div>
                                    <div className="flex-grow-1 order-md-3 order-4" >
                                        <p className="m-0 px-md-3">
                                            Input the particulars of the student for the search. Please provide as much information as possible to help us conduct the search
                                            (eg. Aliases, transfers, highest standard you remember attending, any repeated level)
                                        </p>
                                    </div>

                                </div>
                            </div>

                            <div className="card mt-3 overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body d-flex flex-row justify-content-md-start justify-content-md-between flex-md-nowrap flex-wrap">
                                    <div className="order-1 pe-3 guide-number">
                                        <img src="./images/01Guide/3.png" alt="" />
                                    </div>
                                    <div className="guide-title order-md-2 order-3 px-md-3">
                                        Follow Up
                                    </div>
                                    <div className="order-md-4 order-2 ps-3 guide-icon flex-grow-1 align-self-md-start align-self-end text-right">
                                        <img src="./images/01Guide/School/02.png" alt="" />
                                    </div>
                                    <div className="flex-grow-1 order-md-3 order-4" >
                                        <p className="m-0 px-md-3">
                                            NAS will follow up to verify the requestor's identity. We can only conduct searches for the pupil of the school. We will conduct the search and inform of the outcome within 3 working days.
                                        </p>
                                    </div>

                                </div>
                            </div>

                            <div className="card mt-3 overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body d-flex flex-row justify-content-md-start justify-content-md-between flex-md-nowrap flex-wrap">
                                    <div className="order-1 pe-3 guide-number">
                                        <img src="./images/01Guide/4.png" alt="" />
                                    </div>
                                    <div className="guide-title order-md-2 order-3 px-md-3">
                                        Payment & Delivery
                                    </div>
                                    <div className="order-md-4 order-2 ps-3 guide-icon flex-grow-1 align-self-md-start align-self-end text-right">
                                        <img src="./images/01Guide/Content/05and06.png" alt="" />
                                    </div>
                                    <div className="flex-grow-1 order-md-3 order-4" >
                                        <p className="m-0 px-md-3">
                                            Please login to make payment of S${parseFloat(process.env.REACT_APP_ADMINFEE)} (inclusive of {parseInt(process.env.REACT_APP_GST)}% GST). Upon verification of identity and after payment, NAS will provide a letter stating the outcome of the search to the pupil.
                                        </p>
                                    </div>

                                </div>
                            </div>
                            <div className="guide_button mt-3">
                                <Link to={'/school/disclaimer'} className="btn btn-primary theme-bg-color me-2">Request for search</Link>
                                <Link to={'/'} className="btn btn-secondary me-2">Back</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}





